import { Profile } from "components/workflow/steps";
import { IUser } from "interfaces";

export const Steps = [
  Profile.User.default,
  Profile.Update.default,
];

export type ProfileType = { user: IUser };